import { useEffect, useState } from 'react';

/**
 * Attente par défaut : au-delà de l'intervalle entre deux frappes (~150 ms),
 * en deçà de ce qui se remarque.
 */
export const DELAI_ANTI_REBOND_MS = 250;

/**
 * Retarde la propagation d'une saisie, pour n'interroger le serveur qu'une fois
 * la frappe terminée.
 *
 * Sans lui, chaque lettre est une requête. Taper « bennani » en déclenchait six
 * — « be », « ben », « benn »… — dont cinq répondaient à des préfixes traversés
 * en une fraction de seconde et remplacés avant d'avoir été lus. Comme la
 * recherche compare des sous-chaînes (`LIKE '%…%'`), aucune ne peut s'appuyer
 * sur un index : chacune balaie les clients et les commandes. C'était devenu,
 * de loin, le poste de lecture le plus cher de l'application — devant le
 * tableau de bord.
 *
 * Le champ de saisie, lui, reste branché sur la valeur immédiate : c'est
 * l'appel réseau qu'on retarde, jamais l'affichage de ce qu'on tape.
 *
 * Une valeur vide passe **sans attendre**. La palette efface son terme à
 * l'ouverture ; la faire patienter y laisserait un quart de seconde les
 * résultats de la recherche précédente — servis depuis le cache, donc
 * instantanés et convaincants — soit la réponse à une question qu'on ne pose
 * plus.
 */
export function useAntiRebond(valeur: string, delai = DELAI_ANTI_REBOND_MS): string {
  const [differee, setDifferee] = useState(valeur);

  useEffect(() => {
    if (valeur === '') {
      setDifferee('');
      return;
    }

    const minuteur = setTimeout(() => setDifferee(valeur), delai);
    return () => clearTimeout(minuteur);
  }, [valeur, delai]);

  return differee;
}
